// Network manager (core, no browser specifics)
export class CoreNetworkManager {
  constructor(config) {
    this.config = config;
    // ...core setup (no window, no localStorage)
  }
  // ...core methods (send, retry, queue, etc)
}
